<template>
  <div id="app">
    <google-map />
    <spinner v-show="visible"/>
  </div>
</template>

<script>
import GoogleMap from './components/GoogleMap.vue'
import Spinner from './components/Spinner.vue'

export default {
  name: 'app',
  components: {
    GoogleMap,
    Spinner
  },
    data() {
        return {
          visible: true
        }
    }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #5d0a0a;
  height: 100vh;
}
</style>
